import type { APIRequestBody, APIResponse } from './base-fetch';
import { get, patch } from './base-fetch';

export const notificationTypes = [
  'autoEnhance',
  'commentTag',
  'meetingAttendee',
  'meetingCreated',
  'meetingTag',
  'newProjectRequest',
] as const;

export type NotificationType = (typeof notificationTypes)[number];

export type CommentTagNotificationEntity = 'project' | 'company';
export type CommentTagNotificationData = {
  commentId: string;
  commentedBy: number;
  commenterName: string;
  entityId: string;
  entityTagged: CommentTagNotificationEntity;
};

export type NewProjectRequestNotificationData = {
  projectRequestId: string;
  requesterId: number;
  requesterName: string;
  requesterEmail: string;
};

export type AutoEnhanceNotificationData = {
  companiesCount: number;
  projectId: string;
  projectName: string;
};

export type MeetingAttendeeNotificationData = {
  addedBy: number;
  addedByName: string;
  entityId: string;
  entityTagged: CommentTagNotificationEntity;
  meetingId: string;
};

export type MeetingCreatedNotificationData = {
  meetingId: string;
  organizationId: string;
};

export type MeetingTagNotificationData = {
  entityId: string;
  entityTagged: CommentTagNotificationEntity;
  meetingId: string;
  taggedBy: number;
  taggerName: string;
};

export type Notification = Omit<
  APIResponse<'/api/v4/notifications'>[number],
  'type' | 'data'
> & {
  type: NotificationType;
  data:
    | AutoEnhanceNotificationData
    | CommentTagNotificationData
    | MeetingAttendeeNotificationData
    | MeetingCreatedNotificationData
    | MeetingTagNotificationData
    | NewProjectRequestNotificationData
    | null;
};

export const fetchNotifications = () =>
  get<Notification[]>('/v4/notifications');

export type MarkNotificationReadPayload =
  APIRequestBody<'/api/v4/notifications/mark-read'>;

export const markNotificationAsRead = (payload: MarkNotificationReadPayload) =>
  patch<void, MarkNotificationReadPayload>(
    '/v4/notifications/mark-read',
    payload,
  );
